import React from 'react';

const BackIcon = (props: any) => {
  return (
    <svg
      style={{
        width: '16px',
        height: '16px',
      }}
      xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="3" stroke={props.fill ? props.fill : "#365de6"}>
      <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
    </svg>
  )
}

export default BackIcon;